module.exports = __webpack_public_path__ + "img/overview_vr_pic.5d076507.png";